import { Routes, Route } from 'react-router-dom';

import Inicio from '../pages/Inicio/Inicio';
import Diplomados from '../pages/Diplomados/Diplomados';
import DiplomadoDocenciaUniversitaria from '../pages/Diplomados/DiplomadoDocenciaUniversitaria';
import EducacionContinuaVirtual from '../pages/EducacionVirtual/EducacionContinuaVirtual';
import Institucionalidad from '../pages/Institucionalidad/Institucionalidad';
import Contacto from '../pages/Contacto/Contacto';
import Galeria from '../pages/Galeria/Galeria';
import Cursos from '../pages/Cursos/Cursos';
import ProgramasCursos from '../pages/Cursos/ProgramasCursos';
import FormacionTecnicoLaboral from '../pages/FormacionTecnica/FormacionTecnicoLaboral';
import ProgramaTecnicoLaboral from '../pages/FormacionTecnica/ProgramaTecnicoLaboral';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/diplomados" element={<Diplomados />} />
            <Route path="/diplomados/docencia-universitaria" element={<DiplomadoDocenciaUniversitaria />} />
            <Route path="/virtual" element={<EducacionContinuaVirtual />} />
            <Route path="/institucionalidad" element={<Institucionalidad />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/cursos" element={<Cursos />} />
            <Route path="/cursos/:slug" element={<ProgramasCursos />} />
            <Route path="/formaciontecnicolaboral" element={<FormacionTecnicoLaboral />} />
            <Route path="/formaciontecnicolaboral/:slug" element={<ProgramaTecnicoLaboral />} />
        </Routes>
    );
};

export default AppRoutes;
